import { formatTitle, staticMeta } from '@src/utils/metaUtils';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

interface CommonHelmetProps {
  feature?: string;
  description?: string;
}

function CommonHelmet({ feature, description }: CommonHelmetProps) {
  const meta = staticMeta(useLocation().pathname);

  return (
    <Helmet>
      <title>{feature ? formatTitle(feature) : meta.title}</title>
      <meta
        name='description'
        content={description ?? meta.description}
      />
      <link
        rel='icon'
        href='/favicon.ico'
      />
      <meta
        property='og:title'
        content={feature ? formatTitle(feature) : meta.title}
      />
      <meta
        property='og:description'
        content={description ?? meta.description}
      />
      <meta
        property='og:image'
        content={meta.image}
      />

      <meta
        property='og:url'
        content={meta.url}
      />
      <meta
        property='og:type'
        content='website'
      />
      <meta
        property='og:site_name'
        content={meta.portalName}
      />
      <meta
        name='twitter:card'
        content='summary_large_image'
      />
    </Helmet>
  );
}

export default CommonHelmet;
